import { useEffect, useState } from 'react'
import { useQuery } from '@apollo/client'
import { GET_MIGRANTS_REPORTS_BY_ID } from '../../../../graphql/Catalog/Migrants/migrantsProcess'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import Loader from '../../../Global/Spinner'
import ProgressBarStatusReport from '../../../Global/ProgressBarStatusReport'
import moment from 'moment'
import MigrantsInternalNotes from './MigrantsInternalNotes'
import MigrantsTimeLines from './MigrantsTimeLines'
import Box from '../../../Global/Box'
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'
import { Link } from 'react-router-dom'

const MigrantsProcessHistoryDetails = ({
  reportId,
  user,
}) => {
  // -------------- Hooks --------------
  const [dataReport, setDataReport] = useState(null)

  // -------------- Querys and Mutations --------------
  const { data, loading, error } = useQuery(GET_MIGRANTS_REPORTS_BY_ID, {
    variables: { getMigrantsReportsByIdId: reportId },
  })

  // -------------- UseEffects --------------
  useEffect(() => {
    if (!loading) {
      if (error)
        return toastSweetAlert({
          mode: 'error',
          message: error.message,
        })
      setDataReport(data?.getMigrantsReportsById)
    }
  }, [data, loading, error])

  return (
    <>
      {loading || !dataReport ? (
        <div className="d-flex align-items-center justify-content-center">
          <Loader />
        </div>
      ) : (
        <div className="migrants-process-history-details row">
          <div className="col-12 header-actions">
            <div>
              <Link
                to='/dashboardMigrants/logged/user/history'
                className="btn btn-migrates-white mb-3"
              >
                Atrás
              </Link>
            </div>
          </div>
          <div className="col-12 content-details">
            <div className="header-status mb-3">
              <h5>{dataReport?.process}</h5>
              <ProgressBarStatusReport statusReport={dataReport.status} />
            </div>
            <div className="row content-data">
              <div className="col-12 col-md-6 mb-3">
                <h6>Trámite</h6>
                <span>{dataReport?.groupCategory?.name}</span>
              </div>
              <div className="col-12 col-md-6 mb-3">
                <h6>Fecha de realización del trámite</h6>
                <span>
                  {dataReport?.date
                    ? moment(dataReport?.date).format(
                        'D [de] MMMM[,] YYYY[-] h:mm a'
                      )
                    : ''}
                </span>
              </div>
              <div className="col-12 mb-3">
                <h6>Folio</h6>
                <span>{dataReport?.invoice}</span>
              </div>
              {dataReport?.migrantsFormFields?.map((item) => {
                return (
                  <div className="col-12 col-md-6 mb-3">
                    <h6>{item?.label}</h6>
                    <span>{item?.value}</span>
                  </div>
                )
              })}
            </div>
            {dataReport?.AttachmentsOfReport.length > 0 && (
              <div className="row attachments">
                <ReportAttachments
                  attachments={dataReport?.AttachmentsOfReport}
                />
              </div>
            )}
            <div className="row internal-notes">
              <MigrantsInternalNotes
                document_id={reportId}
                flagSwitchInternalMode={false}
                OnlyInternalMessages={true}
                // refetchNotes={refetchNotes}
                user={user}
              />
            </div>
            <div className="row timeline">
              <MigrantsTimeLines document_id={parseInt(reportId)} />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

const ReportAttachments = ({ attachments }) => {
  const MySwal = withReactContent(Swal)

  // const [uniqueUser, setUniqueUser] = useState([])

  // useEffect(() => {
  //   if (attachments) {
  //     const uniqueUsers = attachments.reduce((acc, attachment) => {
  //       if (!acc.some((user) => user.user_id === attachment.user_id)) {
  //         acc.push({
  //           user_id: attachment.user_id,
  //           user: attachment.UserOfReportAttachment,
  //         })
  //       }
  //       return acc
  //     }, [])
  //     setUniqueUser(uniqueUsers)
  //   }
  // }, [attachments])

  const switchFile = (type_file) => {
    const data = {
      pdf: {
        icon: 'fas fa-file-pdf',
        text: 'PDF',
      },
      img: {
        icon: 'fas fa-image',
        text: 'IMG',
      },
    }
    return (
      <>
        {data[type_file ? type_file : 'img']?.text}
        <i
          className={`${data[type_file ? type_file : 'img'].icon} fa-2x ml-2`}
        />
      </>
    )
  }

  const handleModalImage = (url, id) => {
    MySwal.fire({
      title: (
        <>
          <div className="d-flex justify-content-center align-items-center">
            <i className="fas fa-image mr-2" />
            <span>Vista previa de la imagen {`IMG_${id}.jpg`}</span>
          </div>
          <div className="border"></div>
        </>
      ),
      // titleText: `IMG_${id}.jpg`,
      imageUrl: url,
      imageWidth: 500,
      imageHeight: 440,
      // imageAlt: "Custom image"
      // buttonsStyling: false,
      // confirmButtonText: 'Aceptar',
      showConfirmButton: false,
      showCloseButton: true,
      customClass: {
        title: 'StandarModalTitle',
        htmlContainer: 'StandarModalHtmlContainer',
        confirmButton: 'btn btn-migrates',
        denyButton: 'btn btn-migrates-white',
        footer: 'btn StandarModalFooterLogOut',
      },
    })
  }

  return (
    <div className="row">
      <div className="col-12">
        <Box
          title="Mis archivos adjuntos"
          classNameHeader="card-header py-1"
          content={
            <>
              {attachments?.length === 0 ? (
                'No hay archivos adjuntos'
              ) : (
                <div className="d-flex flex-wrap row">
                  {attachments.map((attachment) => {
                    return (
                      <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mb-3">
                        <span style={{fontSize: '12px'}}>{attachment?.label}</span><br />
                        <div key={attachment.id} className="btn btn-light">
                          {attachment?.type_file === 'img' ? (
                            <a
                              className="link-primary documentLink"
                              style={{ textDecoration: 'none' }}
                              as="button"
                              title="Descargar"
                              onClick={() =>
                                handleModalImage(attachment.url, attachment.id)
                              }
                            >
                              <img
                                src={attachment.url}
                                alt=""
                                width="80px"
                                height="80px"
                              />
                              {/* {switchFile(attachment?.type_file)} */}
                            </a>
                          ) : (
                            <a
                              className="link-primary documentLink"
                              style={{ textDecoration: 'none' }}
                              as="button"
                              href={attachment.url}
                              target="_blank"
                              rel="noreferrer"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Descargar"
                            >
                              {switchFile(attachment?.type_file)}
                            </a>
                          )}
                        </div>
                      </div>
                    )
                  })}
                </div>
              )}
            </>
          }
        />
      </div>
    </div>
  )
}

export default MigrantsProcessHistoryDetails
